export const TABLE_CONSTANTS = {
  DEFAULT_PAGE_SIZE: 10,
  EXPANDER_COLUMN_ID: 'expander',
  STYLING: {
    BORDERS: {
      TABLE: 'border border-neutral-400 rounded-md shadow-md',
      CELL: 'border-b',
    },
    CELL_PADDING: {
      LEFT: 'pl-5',
      RIGHT: 'pr-4',
      TOP: 'pt-5',
      BOTTOM: 'pb-5',
    },
    COLORS: {
      HEADER_BG: 'bg-neutral-200',
      TABLE_BG: 'bg-neutral-0',
      TEXT: 'text-typography',
      TEXT_LIGHT: 'text-typography-light',
    },
    EXPANDER_COLUMN: {
      PADDING: 'px-2',
      WIDTH: 'w-12',
    },
  },
};
